import React, { ComponentProps } from 'react'
import { useTranslation } from 'hooks/useTranslation'
import { OwnPaceRoot, Header, Subheader } from './OwnPace.styles'
import { Button } from 'components/Button'
import { BannerText } from 'components/BannerText'
import Link from 'next/link'

type OwnPaceOwnProps = ComponentProps<typeof OwnPaceRoot>
export type OwnPaceProps = OwnPaceOwnProps & {}

export const OwnPace = (_props: OwnPaceProps) => {
  const { t } = useTranslation()

  return (
    <BannerText background="primary-700">
      <OwnPaceRoot>
        <Header>{t('products-v2:all-products.essential-box.title')}</Header>
        <Subheader>{t('products-v2:all-products.essential-box.description')}</Subheader>
        <Link passHref href="/products/classic-box">
          <Button variant="tertiary">{t('products-v2:all-products.essential-box.cta-button')}</Button>
        </Link>
      </OwnPaceRoot>
    </BannerText>
  )
}

OwnPace.displayName = 'OwnPace'
